/**
 *
 * NumberAnimation
 *
 * Used to animate numbers from 0 to x.
 * Works with integers.
 */


const $ = require( 'jQuery' );
const _throttled = require( './_debounce' );

var NumberAnimation = function (el) {
    this.$el                = $(el);
    this.targetValue        = parseFloat(this.$el.text());
    this.targetValueInt     = parseInt(this.$el.text());
    this.isFloat            = this.targetValue > this.targetValueInt;
    this.animDurationMillis = 1300;
    this.animateWhenInView  = _throttled(333, this.animateWhenInView.bind(this));

    this.init();
};

NumberAnimation.prototype.init = function () {
    this.reset();
    $(document).on('scroll', this.animateWhenInView);
};

NumberAnimation.prototype.countUp = function () {
    if (this.value < this.targetValue) {
        this.value += 0.1;
    }
};

NumberAnimation.prototype.reset = function () {
    this.value = 0;
};

NumberAnimation.prototype.animate = function () {
    var _this = this;

    $({ Counter: 0 }).animate({ Counter: this.targetValue }, {
        duration: this.animDurationMillis,
        easing: 'swing',
        step: function () {
            if(_this.isFloat) {
                _this.$el.text(this.Counter.toFixed(1));
            } else {
                _this.$el.text(Math.ceil(this.Counter));
            }
        }
    })
};

NumberAnimation.prototype.stopScrollListener = function () {
    $(document).off('scroll', this.animateWhenInView);
};

NumberAnimation.prototype.animateWhenInView = function () {
    var y = this.$el[0].getBoundingClientRect().y;

    if (y > 0 && y <= window.innerHeight) {
        this.animate();
        this.stopScrollListener();
    }
};

$(document).ready(function(){
    $('.js-number-counter-animation').each(function(){
        new NumberAnimation(this);
    });
});
